export function getErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  if (error && typeof error === 'object') {
    const maybeMessage = 'message' in error && typeof error.message === 'string' ? error.message.trim() : '';
    const maybeDetails = 'details' in error && typeof error.details === 'string' ? error.details.trim() : '';
    const maybeHint = 'hint' in error && typeof error.hint === 'string' ? error.hint.trim() : '';

    const combined = [maybeMessage, maybeDetails, maybeHint].filter(Boolean).join(' ');
    if (combined) {
      return combined;
    }
  }

  if (typeof error === 'string' && error.trim()) {
    return error;
  }

  return fallback;
}
